import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="if">
                    1.&nbsp;<span className="material-symbols-outlined">call_split</span>&nbsp;{translate('if')}
                </Typography>
                <p><strong>{translate('if')}</strong> is the act of branching out the processing according to the specified condition. If the condition is true, execute the action defined in the block.</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('condition')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>Is the condition.</td>
                                    <td></td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="loop">
                    2.&nbsp;<span className="material-symbols-outlined">cached</span>&nbsp;{translate('loop')}
                </Typography>
                <p><strong>{translate('loop')}</strong> is the act of repeating a process a specified number of times.</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('outputkey')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>Is the current number of iterations (starting at 0).</td>
                                    <td>$i_1</td>
                                </tr>
                                <tr>
                                    <td>{translate('times')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="number" />
                                    </td>
                                    <td>Is the number of repetitions.</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue type="number" />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('outputkey')}</span>
                                <div>$i_1</div>
                            </div>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div>3</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>0</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>1</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>2</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="forearch">
                    3.&nbsp;<span className="material-symbols-outlined">repeat</span>&nbsp;{translate('forearch')}
                </Typography>
                <p><strong>{translate('forearch')}</strong> is the act of repeating the process for each element of the array.</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('outputkey')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>Is the value of each element in the array.</td>
                                    <td>$item_1</td>
                                </tr>
                                <tr>
                                    <td>{translate('iterable')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="array" />
                                    </td>
                                    <td>Is the array to be traversed.</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue type="any" />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('outputkey')}</span>
                                <div>$item_1</div>
                            </div>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('iterable')}</span>
                                <div>{`["red", "green", "blue"]`}</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>red</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>green</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>blue</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="breakif">
                    4.&nbsp;<span className="material-symbols-outlined">do_not_disturb_alt</span>&nbsp;{translate('breakif')}
                </Typography>
                <p><strong>{translate('breakif')}</strong> is the action of exiting the Loop/ForEarch, placing it inside the Loop/ForEach block. If the specified condition is true, exit the loop block (Loop/ForEach) and move on to the next task outside the block. If the iterations are nested, exit the innermost loop.</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('condition')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>Is the condition.</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="wait">
                    5.&nbsp;<span className="material-symbols-outlined">hourglass_top</span>&nbsp;{translate('wait')}
                </Typography>
                <p><strong>{translate('wait')}</strong> is the act of waiting to proceed to the next action.</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('timeout')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="number" />
                                    </td>
                                    <td>Is the waiting time (in milliseconds).</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="runjavascript">
                    6.&nbsp;<span className="material-symbols-outlined">javascript</span>&nbsp;{translate('runjavascript')}
                </Typography>
                <p><strong>{translate('runjavascript')}</strong> is the action that runs JavaScript inside an action.</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('outputkey')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>Is the return value after executing the JavaScript code if any.</td>
                                    <td>$runJavascript_1</td>
                                </tr>
                                <tr>
                                    <td>{translate('code')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>Is the JavaScript code you want to run.</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue type="any" />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('outputkey')}</span>
                                <div>$runJavascript_1</div>
                            </div>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('code')}</span>
                                <div>let a = 1; let b = 2; return a + b;</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>3</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </Box>
    );
}
export default withTranslate(En);